import type { PublicApiEndpoint } from "@constructorfleet/offerings-sdk";

export const uaNotificationsPublicApiEndpoints: {
  basePath: string;
  endpoints: PublicApiEndpoint[];
} = {
  basePath: "/api/website/co-ua",
  endpoints: [
    {
      method: "GET",
      path: "/status",
      summary: "Check your UA notification enrollment status.",
      responseExample: JSON.stringify({ ok: true, enrolled: true }, null, 2),
    },
    {
      method: "POST",
      path: "/enroll",
      summary: "Enroll in UA notifications for your jurisdiction.",
      params: [
        {
          name: "participantId",
          in: "body",
          type: "string",
          required: true,
          description: "Your participant / client ID.",
        },
        {
          name: "stateCode",
          in: "body",
          type: "string",
          required: false,
          description: "Two-letter state code (e.g. CO). Inferred from programId if omitted.",
        },
        {
          name: "programId",
          in: "body",
          type: "string",
          required: false,
          description: "Program identifier (e.g. denver-county-court-probation).",
        },
        {
          name: "jurisdictionId",
          in: "body",
          type: "string",
          required: false,
          description: "Jurisdiction ID for your testing line.",
        },
      ],
      responseExample: JSON.stringify({ ok: true }, null, 2),
      errorCodes: [{ code: 400, description: "participantId is required" }],
    },
    {
      method: "GET",
      path: "/settings",
      summary: "Get your notification preferences and enrollment details.",
      responseExample: JSON.stringify(
        {
          ok: true,
          enrollment: {
            memberId: "user:42",
            selectedStateCode: "CO",
            selectedProgramId: "denver-county-court-probation",
            notificationPreferences: { sms: true, email: false },
          },
        },
        null,
        2
      ),
    },
    {
      method: "PUT",
      path: "/settings",
      summary: "Update your notification preferences.",
      params: [
        {
          name: "notificationPreferences",
          in: "body",
          type: "object",
          required: true,
          description: "Notification preference object, e.g. { sms: true, email: false }.",
        },
      ],
      responseExample: JSON.stringify({ ok: true }, null, 2),
      errorCodes: [{ code: 400, description: "notificationPreferences is required" }],
    },
    {
      method: "GET",
      path: "/jurisdictions",
      summary: "List available jurisdictions, optionally filtered by state.",
      params: [
        {
          name: "stateCode",
          in: "query",
          type: "string",
          required: false,
          description: "Two-letter state code to filter by (e.g. CO).",
        },
      ],
      responseExample: JSON.stringify(
        {
          ok: true,
          jurisdictions: [
            {
              id: 1,
              stateCode: "CO",
              name: "Denver County",
              phoneNumber: "+13035551234",
              color: "Blue",
            },
          ],
        },
        null,
        2
      ),
    },
    {
      method: "GET",
      path: "/programs/:programId",
      summary: "Get details for a specific program.",
      params: [
        {
          name: "programId",
          in: "path",
          type: "string",
          required: true,
          description: "Program identifier (e.g. denver-county-court-probation).",
        },
      ],
      responseExample: JSON.stringify(
        {
          ok: true,
          program: {
            id: "denver-county-court-probation",
            label: "Denver County Court Probation",
            stateCode: "CO",
            phoneNumber: "+13035551234",
          },
        },
        null,
        2
      ),
      errorCodes: [{ code: 404, description: "Program not found" }],
    },
  ],
};
